<template>
    <div>
        <b-row>
        <b-col class="text-center">
            <b-card>
                <div slot="header">
                    <strong>Resultado de la compatibilidad</strong>
                </div>
                <b-row>
                    <b-col>
                        <div class="mb-3 resultadoMatrizC" v-if="resultadoCompatibilidad" :style="'width:'+(resultadoCompatibilidad.text.length*8)+'px;background:'+resultadoCompatibilidad.color+';color:'+colorCompatibilidad+';'">
                            {{ resultadoCompatibilidad.text }}
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
    <b-row class="d-flex justify-content-between"> 
        <b-col class="d-flex justify-content-end" sm="12">
            <b-button variant="primary" class="mr-2" @click="volverInicio()">
                Ingresar productos    
            </b-button>                        
            <b-button variant="secondary" @click="$emit('volverMatriz')">
                <!-- <i class="fa fa-reply fa-lg"></i> -->
                Volver
            </b-button>
        </b-col>
    </b-row>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { getAcls } from "../../plugins/acl";
import loader from "../../containers/loader";

export default {    
    name: "resultadoCompatibilidad",
    data() {
        return {
            colorCompatibilidad: '#333333'
        }
    },
    created() {
        this.idealTextColor(this.resultadoCompatibilidad.color);
    },    
    methods: {
        idealTextColor(bgColor) {
            let nThreshold = 105;
            let components = this.getRGBComponents(bgColor);
            let bgDelta = (components.R * 0.299) + (components.G * 0.587) + (components.B * 0.114);

            this.colorCompatibilidad = ((255 - bgDelta) < nThreshold) ? "#333333" : "#ffffff";   
        },
        getRGBComponents(color) {    
            let r = color.substring(1, 3);
            let g = color.substring(3, 5);
            let b = color.substring(5, 7);

            return {
                R: parseInt(r, 16),
                G: parseInt(g, 16),
                B: parseInt(b, 16)
            };
        },
        volverInicio() {
            this.limpiarResultado();
            this.setPaso(0);
        },
        cerrarPasoAPaso() {
            this.limpiarResultado();
            this.setPaso(0);
            this.$router.push('/matriz-compatibilidad');
        }, 
        ...mapMutations('matrizCompatibilidad', [
            'setPaso',
            'setModalMatriz',
            'limpiarResultado'
        ]),
    },
    computed:{
        ...mapState('matrizCompatibilidad', [
            'selectedEmpresa',
            'paso',
            'resultadoCompatibilidad',
            'modalMatriz'
        ])        
    }
}
</script>
<style>
.resultadoMatrizC {
    font-size: 1rem;
    text-align: center;
    padding: 20px;
    margin: auto;
}
</style>